import React from 'react';
import {Link} from 'react-router';
import './dashboard_dropdown.less';
import cookies from '../../util/cookie';

export default class DashboardDropdown extends React.Component{

  constructor(props){
    super(props);
    this.logout = this.logout.bind(this);
  }

  logout(e) {
    cookies.delete('_sd');
    document.location.href = '/';
  }

  render(){
    return(
      <div className="dashboard-dropdown-wrp">
        <div className="triangle"></div>
        <Link to="/profile" activeClassName="popup-elm-selected" className="dashboard-dropdown-elm">Profile</Link>
        <Link to="/account" activeClassName="popup-elm-selected" className="dashboard-dropdown-elm">Account</Link>
        {/* <div className="dashboard-dropdown-elm">Notifications</div> */}
        <hr id="horizontalLineWrap"></hr>
        <div onClick={this.logout} className="dashboard-dropdown-elm">Sign Out</div>
    </div>
    )
  }

}



// WEBPACK FOOTER //
// app/components/dashboard_dropdown/dashboard_dropdown.jsx